import { RxapDataSource } from 'eurogard-data-source';
import { Injectable, inject } from '@angular/core';
import { PanelAccordionDataSource } from 'eurogard-data-source/accordion';
import {
  NotificationAccordionSubscribedMachinesControllerGetByIdResponse
} from 'open-api-service-feature-user/responses/notification-accordion-subscribed-machines-controller-get-by-id.response';
import {
  NotificationAccordionSubscribedMachinesControllerGetByIdRemoteMethod
} from 'open-api-service-feature-user/remote-methods/notification-accordion-subscribed-machines-controller-get-by-id.remote-method';

@Injectable()
@RxapDataSource('subscribed-machines-panel')
export class SubscribedMachinesPanelDataSource extends PanelAccordionDataSource<NotificationAccordionSubscribedMachinesControllerGetByIdResponse> {
  protected override readonly method = inject(NotificationAccordionSubscribedMachinesControllerGetByIdRemoteMethod);
}
